import React from 'react'
import { useParams } from 'react-router-dom'
import { StudentTopMenuLayout } from '../../Layout/StudentTopMenu/StudentTopMenuLayout'
import { StudentActivitiesList } from './StudentActivitiesList'

const InstructorStudentActivityList = () => {
	const { studentId } = useParams()

	return (
		<StudentTopMenuLayout activeMenu="Activity" pageName="Activity">
			<div className="card mb-4 shadow-sm" style={{ borderRadius: '8px' }}>
				<div className="card-body">
					<StudentActivitiesList studentId={studentId} isStudentView={false} />
				</div>
			</div>
		</StudentTopMenuLayout>
	)
}

export { InstructorStudentActivityList }
